import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-62bee5b1")

_pushScopeId("data-v-62bee5b1")
const _hoisted_1 = { class: "businessInvoiceCustomersContent" }
const _hoisted_2 = { class: "pb-4" }
const _hoisted_3 = { class: "businessInvoiceCustomersFilter" }
const _hoisted_4 = {
  class: "single-filter",
  style: {"width":"min-content"}
}
const _hoisted_5 = { class: "filter-title" }
const _hoisted_6 = { class: "p-relative" }
const _hoisted_7 = { class: "single-filter" }
const _hoisted_8 = { class: "filter-title" }
const _hoisted_9 = { class: "position-relative" }
const _hoisted_10 = { class: "double-filter" }
const _hoisted_11 = { class: "filter-title" }
const _hoisted_12 = { class: "p-relative" }
const _hoisted_13 = { class: "p-relative" }
const _hoisted_14 = { class: "double-filter" }
const _hoisted_15 = { class: "filter-title" }
const _hoisted_16 = { class: "p-relative" }
const _hoisted_17 = { class: "p-relative" }
const _hoisted_18 = { class: "single-filter" }
const _hoisted_19 = { class: "filter-title" }
const _hoisted_20 = { class: "position-relative" }
const _hoisted_21 = {
  class: "single-filter",
  style: {"min-width":"max-content"}
}
const _hoisted_22 = { class: "search-button-wrapper" }
const _hoisted_23 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-search fs-24" }, null, -1)
const _hoisted_24 = {
  id: "desktop-grid",
  class: "desktop-grid"
}
const _hoisted_25 = {
  id: "main-table",
  class: "main-table"
}
const _hoisted_26 = { scope: "col" }
const _hoisted_27 = { class: "checkbox-wrapper" }
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { class: "" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_29 = { scope: "col" }
const _hoisted_30 = { scope: "col" }
const _hoisted_31 = { scope: "col" }
const _hoisted_32 = { scope: "col" }
const _hoisted_33 = { scope: "col" }
const _hoisted_34 = { scope: "col" }
const _hoisted_35 = { scope: "col" }
const _hoisted_36 = { scope: "col" }
const _hoisted_37 = { scope: "col" }
const _hoisted_38 = { scope: "col" }
const _hoisted_39 = { class: "checkbox-wrapper" }
const _hoisted_40 = /*#__PURE__*/_createVNode("span", { class: "" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_41 = { class: "single-ellipsis" }
const _hoisted_42 = { class: "single-ellipsis" }
const _hoisted_43 = { class: "single-ellipsis" }
const _hoisted_44 = { class: "single-ellipsis" }
const _hoisted_45 = { style: {"line-height":"30px","font-weight":"600"} }
const _hoisted_46 = {
  class: "border-footer",
  colspan: "4"
}
const _hoisted_47 = /*#__PURE__*/_createVNode("td", { class: "border-footer" }, null, -1)
const _hoisted_48 = /*#__PURE__*/_createVNode("td", { class: "border-footer" }, null, -1)
const _hoisted_49 = /*#__PURE__*/_createVNode("td", { class: "border-footer" }, null, -1)
const _hoisted_50 = { class: "border-footer" }
const _hoisted_51 = { class: "border-footer" }
const _hoisted_52 = { style: {"line-height":"15px"} }
const _hoisted_53 = { style: {"line-height":"15px"} }
const _hoisted_54 = /*#__PURE__*/_createVNode("td", { class: "border-footer" }, null, -1)
const _hoisted_55 = /*#__PURE__*/_createVNode("td", { class: "border-footer" }, null, -1)
const _hoisted_56 = { class: "row d-flex justify-content-between justify-content-lg-center" }
const _hoisted_57 = { class: "col-4 col-lg-2 order-modify-container" }
const _hoisted_58 = { class: "col-4 col-lg-2 order-modify-container" }
const _hoisted_59 = { class: "my-1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_router_link = _resolveComponent("router-link")
  const _component_OverlayModal = _resolveComponent("OverlayModal")

  return (_openBlock(), _createBlock(_component_OverlayModal, {
    isOpen: _ctx.isOpen,
    "onUpdate:isOpen": _cache[20] || (_cache[20] = ($event: any) => (_ctx.isOpen = $event)),
    style: {"max-width":"unset!important"},
    contentClass: "modal-limit",
    modalWidth: _ctx.maxWidth
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('header.select-order-products')), 1),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('label.order_number')), 1),
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_InputNumber, {
                modelValue: _ctx.filter.orderNumber,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.orderNumber = $event)),
                min: 0,
                style: {"width":"100%","height":"48px"},
                allowEmpty: true,
                useGrouping: false
              }, null, 8, ["modelValue"]),
              (_ctx.filter.orderNumber)
                ? (_openBlock(), _createBlock("i", {
                    key: 0,
                    class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon2",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter.orderNumber = null))
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('product.productName')), 1),
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_Multiselect, {
                class: "Multiselect-filter-item",
                style: {"width":"200px"},
                modelValue: _ctx.filter.productId,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filter.productId = $event)),
                valueProp: "id",
                label: "text",
                options: _ctx.providerProducts,
                "close-on-select": true
              }, null, 8, ["modelValue", "options"]),
              (_ctx.filter.productId)
                ? (_openBlock(), _createBlock("i", {
                    key: 0,
                    class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.filter.productId = ''))
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('newOrder.arrivalDate')), 1),
            _createVNode("div", null, [
              _createVNode("div", _hoisted_12, [
                _createVNode(_component_Calendar, {
                  modelValue: _ctx.dateRange.fromDate,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dateRange.fromDate = $event)),
                  selectionMode: "single",
                  dateFormat: "dd/mm/yy",
                  ref: "calendar",
                  onDateSelect: _ctx.dateChanged,
                  placeholder: _ctx.$t('placeholder.from'),
                  maxDate: _ctx.dateRange.toDate
                }, null, 8, ["modelValue", "onDateSelect", "placeholder", "maxDate"]),
                (_ctx.dateRange.fromDate)
                  ? (_openBlock(), _createBlock("i", {
                      key: 0,
                      class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon3",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.dateRange.fromDate = null))
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_13, [
                _createVNode(_component_Calendar, {
                  modelValue: _ctx.dateRange.toDate,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dateRange.toDate = $event)),
                  selectionMode: "single",
                  dateFormat: "dd/mm/yy",
                  minDate: _ctx.dateRange.fromDate,
                  ref: "calendar",
                  onDateSelect: _ctx.dateChanged,
                  placeholder: _ctx.$t('placeholder.to')
                }, null, 8, ["modelValue", "minDate", "onDateSelect", "placeholder"]),
                (_ctx.dateRange.toDate)
                  ? (_openBlock(), _createBlock("i", {
                      key: 0,
                      class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon3",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.dateRange.toDate = null))
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('label.created-date')), 1),
            _createVNode("div", null, [
              _createVNode("div", _hoisted_16, [
                _createVNode(_component_Calendar, {
                  modelValue: _ctx.dateRange2.fromDate,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.dateRange2.fromDate = $event)),
                  selectionMode: "single",
                  dateFormat: "dd/mm/yy",
                  ref: "calendar",
                  onDateSelect: _ctx.dateChanged,
                  maxDate: _ctx.dateRange2.toDate != null ? _ctx.dateRange2.toDate : new Date(),
                  placeholder: _ctx.$t('placeholder.from')
                }, null, 8, ["modelValue", "onDateSelect", "maxDate", "placeholder"]),
                (_ctx.dateRange2.fromDate)
                  ? (_openBlock(), _createBlock("i", {
                      key: 0,
                      class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon3",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.dateRange2.fromDate = null))
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_17, [
                _createVNode(_component_Calendar, {
                  modelValue: _ctx.dateRange2.toDate,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.dateRange2.toDate = $event)),
                  selectionMode: "single",
                  dateFormat: "dd/mm/yy",
                  minDate: _ctx.dateRange2.fromDate,
                  maxDate: new Date(),
                  ref: "calendar",
                  onDateSelect: _ctx.dateChanged,
                  placeholder: _ctx.$t('placeholder.to')
                }, null, 8, ["modelValue", "minDate", "maxDate", "onDateSelect", "placeholder"]),
                (_ctx.dateRange2.toDate)
                  ? (_openBlock(), _createBlock("i", {
                      key: 0,
                      class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon3",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.dateRange2.toDate = null))
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_18, [
            _createVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('label.coupon-name')), 1),
            _createVNode("div", _hoisted_20, [
              _createVNode(_component_Multiselect, {
                class: "Multiselect-filter-item",
                style: {"width":"154px"},
                modelValue: _ctx.filter.couponId,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.filter.couponId = $event)),
                valueProp: "id",
                label: "text",
                options: _ctx.providerCoupons,
                "close-on-select": true
              }, null, 8, ["modelValue", "options"]),
              (_ctx.filter.couponId)
                ? (_openBlock(), _createBlock("i", {
                    key: 0,
                    class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.filter.couponId = null))
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_21, [
            _createVNode("span", {
              class: "clear-all",
              onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.clearFilter && _ctx.clearFilter(...args)))
            }, _toDisplayString(_ctx.$t('button.clearAll')), 1)
          ]),
          _createVNode("div", _hoisted_22, [
            _createVNode("button", {
              type: "button",
              onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
            }, [
              _hoisted_23
            ])
          ])
        ]),
        _createVNode("div", _hoisted_24, [
          _createVNode("table", _hoisted_25, [
            _createVNode("thead", null, [
              _createVNode("tr", null, [
                _createVNode("th", _hoisted_26, [
                  _createVNode("span", _hoisted_27, [
                    _createVNode("input", {
                      class: "inp-cbx",
                      checked: _ctx.checkAll,
                      onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.selectAll && _ctx.selectAll(...args))),
                      id: "onSelectAll",
                      type: "checkbox",
                      style: {"display":"none"}
                    }, null, 40, ["checked"]),
                    _createVNode("label", {
                      class: ["cbx same-size w-100", { 'single-line': true }],
                      for: "onSelectAll"
                    }, [
                      _hoisted_28
                    ])
                  ])
                ]),
                _createVNode("th", _hoisted_29, _toDisplayString(_ctx.$t('label.order_number')), 1),
                _createVNode("th", _hoisted_30, _toDisplayString(_ctx.$t('product.productName')), 1),
                _createVNode("th", _hoisted_31, _toDisplayString(_ctx.$t('label.coupon-name')), 1),
                _createVNode("th", _hoisted_32, _toDisplayString(_ctx.$t('coupons.customer-type')), 1),
                _createVNode("th", _hoisted_33, _toDisplayString(_ctx.$t('label.customer_name')), 1),
                _createVNode("th", _hoisted_34, _toDisplayString(_ctx.$t('label.total-in-order')), 1),
                _createVNode("th", _hoisted_35, _toDisplayString(_ctx.$t('label.total-in-local')), 1),
                _createVNode("th", _hoisted_36, _toDisplayString(_ctx.type == _ctx.invoiceType.Debit ? _ctx.$t('label.left-to-cover-invoice') : _ctx.$t('label.covered-by-invoices')), 1),
                _createVNode("th", _hoisted_37, _toDisplayString(_ctx.$t('label.created-date')), 1),
                _createVNode("th", _hoisted_38, _toDisplayString(_ctx.$t('newOrder.arrivalDate')), 1)
              ])
            ]),
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.customersToView, (row, index) => {
                return (_openBlock(), _createBlock("tr", { key: index }, [
                  _createVNode("td", null, [
                    _createVNode("span", _hoisted_39, [
                      _createVNode("input", {
                        class: "inp-cbx",
                        checked: _ctx.isChecked(row.id),
                        value: row.id,
                        onChange: ($event: any) => (_ctx.onSelect(row.id)),
                        id: 'customer-' + row.id,
                        type: "checkbox",
                        style: {"display":"none"}
                      }, null, 40, ["checked", "value", "onChange", "id"]),
                      _createVNode("label", {
                        class: ["cbx same-size w-100", { 'single-line': true }],
                        for: 'customer-' + row.id
                      }, [
                        _hoisted_40
                      ], 8, ["for"])
                    ])
                  ]),
                  _createVNode("td", null, [
                    _createVNode(_component_router_link, {
                      class: "is-link",
                      to: {
                                        name: 'order',
                                        params: { id: row.orderId }
                                    },
                      target: "_blank"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(row.orderNumber), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createVNode("td", _hoisted_41, [
                    _createVNode(_component_router_link, {
                      class: "is-link",
                      to: {
                                        name: 'product',
                                        params: { id: row.productId, tab: 1 }
                                    },
                      target: "_blank"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(row.productName), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createVNode("td", _hoisted_42, [
                    _createVNode(_component_router_link, {
                      class: "is-link c-pointer",
                      to: {
                                        name: 'coupon-edit',
                                        params: { couponId: row.couponId }
                                    },
                      target: "_blank"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(row.couponName), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createVNode("td", _hoisted_43, _toDisplayString(row.customerTypeName), 1),
                  _createVNode("td", _hoisted_44, _toDisplayString(row.customerName), 1),
                  _createVNode("td", null, _toDisplayString(_ctx.formatAmount(row.amount)) + " " + _toDisplayString(row.currencySymbol), 1),
                  _createVNode("td", null, _toDisplayString(_ctx.formatAmount(row.amountInLocal)) + " " + _toDisplayString(_ctx.localCurrencySymbolValue), 1),
                  _createVNode("td", null, _toDisplayString(_ctx.formatAmount(row.coverByInvoicesInLocal)) + " " + _toDisplayString(_ctx.localCurrencySymbolValue), 1),
                  _createVNode("td", null, _toDisplayString(row.createdDate), 1),
                  _createVNode("td", null, _toDisplayString(row.arrivalDate), 1)
                ]))
              }), 128))
            ]),
            _createVNode("tfoot", null, [
              _createVNode("tr", _hoisted_45, [
                _createVNode("th", _hoisted_46, _toDisplayString(_ctx.selectedCount) + " " + _toDisplayString(_ctx.$t('label.selected-out-of ')) + " " + _toDisplayString(_ctx.customers.length), 1),
                _hoisted_47,
                _hoisted_48,
                _hoisted_49,
                _createVNode("td", _hoisted_50, _toDisplayString(_ctx.$t('cashier.label.total')) + " " + _toDisplayString(_ctx.formatAmount(_ctx.totalAmountValue)) + " " + _toDisplayString(_ctx.localCurrencySymbolValue), 1),
                _createVNode("td", _hoisted_51, [
                  _createVNode("div", _hoisted_52, " (" + _toDisplayString(_ctx.formatAmount(_ctx.selectedAmountCoverByInvoces)) + " " + _toDisplayString(_ctx.localCurrencySymbolValue) + ") ", 1),
                  _createVNode("div", _hoisted_53, "  " + _toDisplayString(_ctx.formatAmount(_ctx.amountCoverByInvocesValue)) + " " + _toDisplayString(_ctx.localCurrencySymbolValue), 1)
                ]),
                _hoisted_54,
                _hoisted_55
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_56, [
          _createVNode("div", _hoisted_57, [
            _createVNode("button", {
              type: "button",
              class: "order-modify-button-wrapper dark-circle-button",
              onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
            }, _toDisplayString(_ctx.$t('button.cancel')), 1)
          ]),
          _createVNode("div", _hoisted_58, [
            _createVNode("button", {
              type: "button",
              class: "order-modify-button-wrapper btn-green",
              onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
            }, [
              _createVNode("div", _hoisted_59, _toDisplayString(_ctx.$t('button.add')), 1)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen", "modalWidth"]))
})